import React from 'react';

const Toast = ({ show, message, type, onClose }) => {
    if (!show) return null;

    const getToastStyle = () => {
        const baseStyle = {
            position: 'fixed',
            top: '20px',
            right: '20px',
            padding: '15px 20px',
            borderRadius: '5px',
            color: 'white',
            zIndex: 1000,
            maxWidth: '300px',
            cursor: 'pointer'
        };

        switch (type) {
            case 'success':
                return { ...baseStyle, backgroundColor: '#28a745' };
            case 'error':
                return { ...baseStyle, backgroundColor: '#dc3545' };
            case 'warning':
                return { ...baseStyle, backgroundColor: '#ffc107', color: '#212529' };
            case 'info':
                return { ...baseStyle, backgroundColor: '#17a2b8' };
            default:
                return { ...baseStyle, backgroundColor: '#6c757d' };
        }
    };

    return (
        <div style={getToastStyle()} onClick={onClose}>
            {message}
        </div>
    );
};

export default Toast;